import { Typography, styled } from '@mui/material';

export const TypographyStyled = styled(Typography)({
  whiteSpace: 'pre-line',
}) as typeof Typography;
